module.exports = __webpack_public_path__ + "img/Transfers.c2aa253b.svg";